import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { ConfigService } from '@shared/services/config.service'
import { TranslatePipe } from '@ngx-translate/core'

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class SupportComponent {
  config = inject(ConfigService)
}
